import { ChevronRight, Home } from 'lucide-react';
import { Link, useLocation } from 'react-router-dom';
import { humanizeSlug } from '../../utils/slug';
import { Container } from './Container';

export function Breadcrumbs() {
  const location = useLocation();
  const parts = location.pathname.split('/').filter(Boolean);

  if (!parts.length) return null;

  return (
    <nav aria-label="Breadcrumb" className="border-b border-white/10 bg-ink-950">
      <Container className="flex min-h-12 items-center gap-2 text-sm text-white/50">
        <Link to="/" aria-label="Home" className="rounded p-1 text-gold-300 hover:text-gold-100 focus:outline-none focus-visible:ring-2 focus-visible:ring-gold-300">
          <Home className="h-4 w-4" />
        </Link>
        {parts.map((part, index) => {
          const href = `/${parts.slice(0, index + 1).join('/')}`;
          const current = index === parts.length - 1;
          return (
            <span key={href} className="flex items-center gap-2">
              <ChevronRight className="h-4 w-4" aria-hidden="true" />
              {current ? <span className="font-medium text-ink-100">{humanizeSlug(part)}</span> : <Link to={href} className="hover:text-gold-300">{humanizeSlug(part)}</Link>}
            </span>
          );
        })}
      </Container>
    </nav>
  );
}
